import React, { useState } from "react";
import { Form, InputGroup, Offcanvas, Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { studyMedicalReviewServices } from "../../../../APIServices/studyMedicalReviewServices";

const MediaclReviewAction = ({ Show, Hide, Title, studyId, StudyMode, selectedIds, selectedSiteIds, getSubjectMedicalReviewTask }) => {

  const [loader, setLoader] = useState(false);
  const [password, setPassword] = useState("");
  const [status, setStatus] = useState("completed");

  const completeBulkTaskSubjectForMedicalReview = async () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to medical review sign this selected form?",
      icon: "warning",
      showCancelButton: true,
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, sign it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        setLoader(true);
        let userData = {}
        userData.studyId = studyId
        userData.siteIds = selectedSiteIds
        userData.reviewIds = selectedIds
        userData.mode = StudyMode
        userData.status = status
        userData.password = password
        let data = await studyMedicalReviewServices.completeBulkTaskSubjectForMedicalReview(userData)
        if (data?.statusCode === 200) {
          getSubjectMedicalReviewTask()
          Hide()
        }
        setLoader(true)
      }
    });
  };
  return (
    <>
      <Offcanvas show={Show} onHide={Hide} placement="end">
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>{Title}</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Form.Group className="pt-2">
            <Form.Label className="mb-1 fw-bold">Status <abbr className="text-danger">*</abbr></Form.Label>
            <Form.Select value={status} onChange={(e) => setStatus(e.target.value)}>
              <option value="">Select Status</option>
              <option value="completed">Pass Review</option>
              <option value="rejected">Fail Review</option>
            </Form.Select>
          </Form.Group>
          <Form.Group className="pt-2">
            <Form.Label className="mb-1 fw-bold">Password <abbr className="text-danger">*</abbr></Form.Label>
            <Form.Control value={password} onChange={(e) => setPassword(e.target.value)} type={`password`} placeholder="Account Password" />
          </Form.Group>
        </Offcanvas.Body>
        <div className="p-2 bg-light border-top shadow-sm hstack justify-content-end gap-2">
          <button
            disabled={loader || !password || !status}
            onClick={completeBulkTaskSubjectForMedicalReview}
            className="updateProfile">
            {loader ? (
              <div className="hstack gap-2">
                <Spinner size="sm" /> Signing...
              </div>
            ) : (
              "Sign Now"
            )}
          </button>
        </div>
      </Offcanvas>
    </>
  );
};

export default MediaclReviewAction;
